var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup3041(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "#E7F4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 32,
    height: 32,
    fill: "white",
    fillOpacity: 0.01
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 21,
    width: 5.33333,
    height: 5.33333,
    rx: 2.66667,
    transform: "rotate(90 35 21)",
    stroke: "#212134",
    strokeWidth: 1.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 31.668,
    width: 5.33333,
    height: 5.33333,
    rx: 2.66667,
    transform: "rotate(90 35 31.668)",
    stroke: "#212134",
    strokeWidth: 1.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18.332,
    width: 5.33333,
    height: 5.33333,
    rx: 2.66667,
    transform: "rotate(-90 15 18.332)",
    stroke: "#212134",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.668 19.668V30.3346C17.668 32.2203 17.668 33.1631 18.2538 33.7488C18.8395 34.3346 19.7824 34.3346 21.668 34.3346H29.668",
    stroke: "#212134",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.668 18.332V19.6654C17.668 21.551 17.668 22.4938 18.2538 23.0796C18.8395 23.6654 19.7824 23.6654 21.668 23.6654H29.668",
    stroke: "#212134",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3041);
export default __webpack_public_path__ + "static/media/Group 3041.4228d4a5b51dd883de962836ba21a103.svg";
export { ForwardRef as ReactComponent };